import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExploreModeService } from '../../services/explore_mode.service';
import { LoaderComponent } from "../../utility components/loader/loader.component";
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  imports: [CommonModule, LoaderComponent],
  styleUrl: './pop-up.component.scss'
})
export class PopUpComponent {
  selectedFileName: string | null = null;
  selectedFile: File | null = null;
  jsonDownloadUrl: string | null = null;
  isLoading: boolean = false;
  isFileProcessed: boolean = false;
  processedFile: File | null = null;

  @Input() isOpen: boolean | undefined;
  @Output() popupClosed = new EventEmitter<void>();
  @Output() processedFileEmitted = new EventEmitter<File>();



  constructor(private exploreModeService: ExploreModeService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen']) {
      if (changes['isOpen'].currentValue) {
        this.disableBodyScroll();
        this.resetUploadState();
      } else {
        this.enableBodyScroll();
      }
    }
  }

  close() {
    this.enableBodyScroll();
    this.popupClosed.emit();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFile = input.files[0];
      this.selectedFileName = this.selectedFile.name;
    }
  }

  uploadtrigger() {
    if (this.processedFile) {
      this.processedFileEmitted.emit(this.processedFile);
      console.log("Processed file emitted:", this.processedFile);

      this.popupClosed.emit(); // Emit event to close popup

      setTimeout(() => {
        this.router.navigate(['/home']); // Just to refresh UI, but optional
      }, 500);
    } else {
      alert("No processed file available to upload.");
    }
  }




  submitFile() {
    if (!this.selectedFile) {
      alert("Please select a file before submitting.");
      return;
    }

    this.isLoading = true;
    this.exploreModeService.uploadSampleFile(this.selectedFile).subscribe(
      (response: any) => {
        setTimeout(() => {
          this.isLoading = false; // Hide loader after processing
          this.createDownloadableJson(response);
          this.isFileProcessed = true;

        }, 1500); // Add a delay for smoother transition
      },
      (error: any) => {
        setTimeout(() => {
          this.isLoading = false; // Hide loader
          console.error("API error:", error);
          alert("Failed to process file. Please try again.");
        }, 2000); // Slight delay before hiding loader
      }
    );

    // const fakeApiResponse = {
    //   "dexcat_mode": { "explore_mode": { "enabled": true }, "normal_mode": { "enabled": false } },
    //   "dri_threshold": 0,
    //   "insights": { "Columns": { "Cost": "int64", "Primary Key": "object", "Quantity": "int64", "Region": "object" } },
    //   "logging": {
    //     "enable_colors": true,
    //     "format": "%(asctime)s - %(name)s - (%(funcName)s) - %(levelname)s - %(message)s",
    //     "level": "WARNING",
    //     "log_colors": { "CRITICAL": "purple", "DEBUG": "blue", "ERROR": "red", "INFO": "green", "WARNING": "yellow" }
    //   },
    //   "paths": { "data_dir": "./raw_csv", "log_dir": "./logs", "output_dir": "./processed_csv/", "temp_dir": "./temp/" },
    //   "price_engine_model": "cost_plus",
    //   "regex_pattern": {
    //     "Cost": ["^(\\d+)$"], "Primary Key": ["^(\\d+|.+|[A-Z]+\\d+[A-Z]+\\d+)$"],
    //     "Quantity": ["^(\\d+)$"], "Region": ["^(.+)()(.+)$"]
    //   }
    // };

    // setTimeout(() => {
    //   this.isLoading = false;
    //   this.createDownloadableJson(fakeApiResponse);
    //   this.isFileProcessed = true; // Hide upload UI and show download options
    // }, 1000);
  }

  disableBodyScroll() {
    document.body.style.overflow = 'hidden';
  }

  enableBodyScroll() {
    document.body.style.overflow = '';
  }

  createDownloadableJson(data: any) {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    this.jsonDownloadUrl = URL.createObjectURL(blob);

    // Create a File object and store it for emitting later
    this.processedFile = new File([blob], "config.json", { type: 'application/json' });
  }


  resetUploadState() {
    this.selectedFileName = null;
    this.selectedFile = null;
    this.jsonDownloadUrl = null;
    this.isFileProcessed = false;

    const fileInput = document.getElementById('dropzone-file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
}
